import { render, staticRenderFns } from "./AMap.vue?vue&type=template&id=a5070a8e&"
import script from "./AMap.vue?vue&type=script&lang=js&"
export * from "./AMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports